import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import { useNavigate } from "react-router-dom";
import logo from "../Images/Logo.png";

function Navbar() {
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState("/");
    const [menuOpen, setMenuOpen] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        setActivePage(window.location.pathname);
    }, []);

    const handleNavigation = (path) => {
        setActivePage(path);
        navigate(path);
        setMenuOpen(false);
    };

    return (
        <nav className="nav">
            <div className="logo-container">
                <ScrollLink to="home" smooth={true} duration={500} className="logo">
                    <img src={logo} alt="Logo" />
                </ScrollLink>
                <h1 className="company-heading">VISUAR SOLUTIONS</h1>
            </div>

            {/* Hamburger menu icon */}
            <label className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                <span className={`nav-icon ${menuOpen ? "open" : ""}`}></span>
            </label>

            {/* Menu Items */}
            <ul className={`menu ${menuOpen ? "open" : ""}`}>
                <li>
                    <button className={`nav-button ${activePage === "/" ? "active" : ""}`} onClick={() => handleNavigation("/")}>
                        Home
                    </button>
                </li>
                <li>
                    <button className={`nav-button ${activePage === "/services" ? "active" : ""}`} onClick={() => handleNavigation("/services")}>
                        Our Services
                    </button>
                </li>
                <li>
                    <button className={`nav-button ${activePage === "/projects" ? "active" : ""}`} onClick={() => handleNavigation("/projects")}>
                        Projects
                    </button>
                </li>
                <li>
                    <button className={`nav-button ${activePage === "/contact" ? "active" : ""}`} onClick={() => handleNavigation("/contact")}>
                        Reach us
                    </button>
                </li>
                <button className="explore" onClick={() => setShowPopup(true)}>Let's Meet</button>
            </ul>

            {/* Popup Modal for Calendly */}
            {showPopup && (
                <div className={`popup-overlay ${showPopup ? "show" : ""}`}>
                    <div className={`popup-content ${showPopup ? "show" : ""}`}>
                        <button className="close-popup" onClick={() => setShowPopup(false)}>✖</button>
                        <iframe
                            src="https://calendly.com/215160-aack"
                            style={{ width: "100%", height: "500px", border: "none" }}
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            )}
        </nav>
    );
}

export default Navbar;
